<template>
  <div class="branch-selection tw-flex tw-flex-col tw-items-center tw-mt-8">
    <div class="tw-w-full">
      <h2 style="color: #114cac;" class="tw-text-2xl tw-font-semibold tw-mb-4">
        You can now select a valuer to value your vehicle
      </h2>
      <div class="tw-w-full tw-p-10 tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-10">
        <div class="tw-grid tw-grid-flow-row tw-gap-5 tw-my-8  sm:tw-grid-cols-2 lg:tw-grid-cols-3">
          <div
            v-for="(valuer, i) in valuers"
            :key="i"
            :class="[
              'pt-10 pb-5 px-10 tw-flex tw-flex-col tw-align-center tw-justify-center tw-border-4 tw-shadow-lg tw-rounded-lg',
              selectedValuerId === valuer.id ? 'tw-border-blue-500' : 'tw-border-gray-300'
            ]"
            @click="setValuerId(valuer.id)"
          >
            <img :src="valuer.logoUrl" :alt="[valuer.name, ' VALUERS']" />
            <h3 class="c-title c-gray-text tw-text-base tw-text-center">
              {{ valuer.name + ' VALUERS' }}
            </h3>
            <h3 class="title-font c-blue-text tw-text-base tw-text-center">
              {{ valuer.phoneNumber }}
            </h3>
          </div>
        </div>
        <!-- Form Section -->
        <div class="form-card tw-p-6 tw-rounded-lg tw-shadow-md tw-bg-white tw-w-full lg:tw-w-1/2">
          <v-form ref="form">
          <v-text-field
              v-model="date"
              label="Select Valuation Date"
              type="date"
              class="tw-mb-4"
              :rules="[required('Select date when you wish your vehicle to be valued')]"
              placeholder="Select valuation date"
              :min="minDate"
          ></v-text-field>
          <v-select
              v-model="time"
              label="Select Valuation Time"
              class="tw-mb-4"
              :rules="[required('Select time when you wish your vehicle to be valued')]"
              placeholder="Select valuation time"
              :items="timeOptions"
              flat
          ></v-select>

        </v-form>
        </div>
        <v-btn
          class="tw-normal-case tw-px-30 tw-rounded-none c-title"
          color="primary"
          large
          @click="proceed"
          :disabled="!date || !time"
        >
          Next
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import validations from '@/utils/validations';
import axios from 'axios';
import { formatDate, timeNow } from '@/utils/time';

export default {
  name: 'ValuerSelection',
  data() {
    return {
      date: null,
      time: null,
      selectedPolicy: null,
      timeOptions: [
        { text: 'morning', Value: 'morning' },
        { text: 'afternoon', value: 'afternoon' },
      ],
      selectedValuerId: null,
      pageLoading: false,
      minDate: this.calculateMinDate(),
      valuers: [{
        id: null,
        name: null,
        identifier: null,
        phoneNumber: null,
        logoUrl: null,
        credentialType: null,
        status: true,
      }],
      ...validations,
      form: {
        isValid: true,
        dateMenu: false,
        date: '',
        time: '',
        location: '',
        terms: '',
      },
      dialog: false,
    };
  },
  watch: {
    selectedValuerId: {
      handler(newValue) {
        if (newValue) {
          this.$refs.form.validate();
        }
      },
    },
    date() {
      this.saveValuationDetails();
    },
    time() {
      this.saveValuationDetails();
    },
  },
  mounted() {
    axios.get('/motor/api/valuers/all')
      .then((response) => {
        this.valuers = response.data.data;

        const savedValuationData = JSON.parse(localStorage.getItem('valuationDetails')) || {};

        if (savedValuationData.selectedValuerId) {
          this.selectedValuerId = savedValuationData.selectedValuerId;
        } else if (this.valuers && this.valuers?.length > 0) {
          this.selectedValuerId = this.valuers[0].id;
        }

        // Restore date and time if saved
        if (savedValuationData.date) {
          this.date = savedValuationData.date;
        }
        if (savedValuationData.time) {
          this.time = savedValuationData.time;
        }
      });
  },
  computed: {
    computedDateFormatted() {
      return formatDate(this.form.date);
    },
  },
  methods: {
    calculateMinDate() {
      const today = new Date();
      return today.toISOString().split('T')[0];
    },
    required(message) {
      return (value) => !!value || message;
    },
    timeNow,
    setValuerId(valuerId) {
      this.selectedValuerId = valuerId;
      this.saveValuationDetails();
    },
    proceed() {
      const formPayload = JSON.parse(localStorage.getItem('formPayload')) || {};
      const customerId = formPayload.customerId;
      const selectedValuer = this.valuers?.find((valuer) => valuer.id === this.selectedValuerId);
      const quoteId = localStorage.getItem('quoteId');
      const payload = {
        address: 'Nairobi,  Kenya',
        customerId,
        date: this.date,
        latitude: 0.0,
        longitude: 0.0,
        quoteId,
        time: this.time,
        valuerId: selectedValuer.id,
      };
      axios
        .post('/motor/api/policy/bookEvaluator', payload)
        .then((response) => {
          if (response.data.code === 0) {
            // Save valuation details before proceeding
            this.saveValuationDetails();

            this.$toast.success('Evaluator details booked successfully',
              'Valuers details');
            this.$emit('next');
          } else {
            this.$toast.error(
              response.data.message,
              'Valuers Details Record error',
            );
          }
        });
    },
    saveValuationDetails() {
      // Save valuation details to localStorage
      localStorage.setItem('valuationDetails', JSON.stringify({
        selectedValuerId: this.selectedValuerId,
        date: this.date,
        time: this.time,
      }));
    },
  },
};

</script>

<style scoped>
.branch-selection {
  padding: 2rem;
  background-color: #f9f9f9;
}

button {
  transition: all 0.3s ease;
}
.v-select {
  border: transparent !important;
  border-radius: 8px;
}
.no-border .v-input__control {
  border: none !important;
  box-shadow: none !important;
}
</style>
